<template>
  <Dashboard grafana-path="/d/VPn2fxqHJ/fico-sign-violations-pivot" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

export default {
  name: "FicoSignViolationsDriverPivot",

  routing: {
    localizationKey: "menu.tab.sign_violations",
    icon: "mdi-table",
    path: "/fico_sign_violations",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Dashboard,
  },
};
</script>
